import React, { ChangeEvent } from "react";
import { Form, Row, Col, FormCheckProps } from "react-bootstrap";
import { WrappedFieldProps } from "redux-form";
import CustomTooltip from "../../components/atoms/CustomTooltip";

interface CustomFieldProps {
  selectedValue: string;
  label?: string;
  id?: string;
  options: Array<{ id: number | string; isDisabled?: boolean; label: string; value: string; siblingComponent?: any }>;
  inline?: boolean | undefined;
  title: string;
  requiredError?: boolean;
  placeholder: string;
  required: boolean;
  disabled: boolean;
  className: string;
  dataTestId: string;
}

type Props = WrappedFieldProps & CustomFieldProps & FormCheckProps;
const ReduxRadio = (props: Props) => {
  const {
    input,
    selectedValue,
    label,
    id,
    options,
    title,
    required,
    inline,
    disabled,
    requiredError,
    dataTestId,
    className = "",
    meta: { touched, error },
  } = props;
  const uniqueId = id ? id : input.name;

  return (
    <Form.Group className={className}>
      {label && (
        <Form.Label className={touched && error ? "is-invalid" : ""}>
          {required && <i className="fas fa-asterisk"></i>}&nbsp;{label}
        </Form.Label>
      )}
      {options.map((item) => {
        return (
          <div key={item.id} 
            className="custom-input-box">
            <Form.Check 
              {...input} 
              data-testid={dataTestId} 
              disabled={disabled || item.isDisabled} 
              inline={inline} 
              id={item.id + "_" + uniqueId} 
              type="radio" 
              className={`${item.value === selectedValue ? `astm-custom-radio active${touched && error ? " is-invalid" : ""}` : `astm-custom-radio ${touched && error ? " is-invalid" : ""}`} ${disabled || item.isDisabled ? "disabled" : ""}`} 
              label={item.label} 
              value={item.value} 
              checked={item.value === selectedValue} 
            />
            {item.siblingComponent && title && <CustomTooltip title={title} placement="top" className="custom-tooltip-panel" HTMLElement={<i aria-hidden="true" className="far fa-info-circle astm-icon ml8"></i>} />}
          </div>
        );
      })}
      {touched && !disabled && error && <div className="invalid-feedback">{requiredError ? requiredError : error}</div>}
    </Form.Group>
  );
};

export default ReduxRadio;
